import type { UseQueryResult } from "@edreamsodigeo/frontend-api-client";
import { useQuery } from "@edreamsodigeo/frontend-api-client";

import useGetTripTokenFromUrl from "~/clientState/hooks/useGetTripTokenFromUrl";
import { GET_TRIP } from "~/clientState/providers/operations/trip";
import type { GetTripQuery, GetTripQueryVariables } from "~/generated/graphql";

const useGetTripInformationQuery = (): UseQueryResult<
  GetTripQuery,
  GetTripQueryVariables
> => {
  const token = useGetTripTokenFromUrl();

  return useQuery<GetTripQuery, GetTripQueryVariables>(GET_TRIP, {
    variables: {
      token,
    },
    skip: !token,
  });
};

export default useGetTripInformationQuery;
